export const errors = {
  'Page not available': 'Seite nicht verfügbar',
  'Something went wrong, please try again later.':
    'Etwas ist schiefgelaufen, bitte versuche es später erneut.',
  Home: 'Startseite',
};
